import { render } from "./wanshan.vue?vue&type=template&id=6ac114fe&scoped=true"
import script from "./wanshan.vue?vue&type=script&lang=js"
export * from "./wanshan.vue?vue&type=script&lang=js"

import "./wanshan.vue?vue&type=style&index=0&id=6ac114fe&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ac114fe"]])

export default __exports__